import { render, staticRenderFns } from "./CategoriaEditModal.vue?vue&type=template&id=45b9203d"
import script from "./CategoriaEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriaEditModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports